<template>
  <div class="border-box-4" :ref="ref">
    <div id="showDiv" v-show="showDiv" style="position: absolute;width: 100%;height: 100%;"></div>
    <svg class="border-svg-container" :width="width" :height="height">
      <defs>
        <linearGradient :id="`linear-gradient` + color" x1="100%" y1="0%" x2="0%" y2="0%">
          <stop offset="0%" :stop-color="mergedColor[0]" stop-opacity="0.2"></stop>
          <stop offset="100%" :stop-color="mergedColor[1]" stop-opacity="1"></stop>
        </linearGradient>
        <linearGradient :id="`verticalGradient`+ color" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" :stop-color="mergedColor[0]" stop-opacity="0.2" />
          <stop offset="100%" :stop-color="mergedColor[1]" stop-opacity="1" />
        </linearGradient>
        <linearGradient :id="`linear-gradientIdle-right`+ color" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" :stop-color="mergedColor[0]" stop-opacity="0.2"></stop>
          <stop offset="100%" :stop-color="mergedColor[1]" stop-opacity="1"></stop>
        </linearGradient>
        <linearGradient :id="`verticalGradient-top`+ color" x1="0%" y1="100%" x2="0%" y2="40%">
          <stop offset="0%" :stop-color="mergedColor[0]" stop-opacity="0.2" />
          <stop offset="100%" :stop-color="mergedColor[1]" stop-opacity="1" />
        </linearGradient>

        <filter :id="`Filter-${color}`">
          <feOffset in="SourceAlpha" dx="0" dy="0" />
          <feGaussianBlur result="blurOut" stdDeviation="5.657" />
          <feFlood :flood-color="mergedColor[3]" result="floodOut" />
          <feComposite operator="out" in="floodOut" in2="blurOut" result="compOut" />
          <feComposite operator="in" in="compOut" in2="SourceAlpha" />
          <feComponentTransfer><feFuncA type="linear" slope="0.36"/></feComponentTransfer>
          <feBlend mode="normal" in2="SourceGraphic" />
        </filter>
      </defs>
      <!--   背景阴影 -->
      <g :filter="isSelected ?`url(#Filter-${color})`:''">
        <path fill-rule="evenodd"  :fill="mergedColor[2]"
              :d="`M15 2 L${width - 5} 1 L${width - 5} ${height - 15} L${width - 15 - 2} ${height - 1.5} L1 ${height - 1.5} L1 16 L16 1`"/>
      </g>

      <!--   边框   -->
<!--      <path :stroke="`url(#linear-gradient${color})`" fill-rule="evenodd" stroke-width="0.0125rem" stroke-linecap="butt" stroke-linejoin="miter" fill-opacity="0" opacity="0.841"-->
<!--            :d="`M16 1 L${width - 5} 1 L${width - 5} ${height - 15} L${width - 15 - 2} ${height - 1.5} L1 ${height - 1.5} L1 16 L16 1`"/>-->
      <path :stroke="`url(#linear-gradient${color})`" fill-rule="evenodd" stroke-width="0.025rem" stroke-linecap="butt" stroke-linejoin="miter" fill-opacity="0"
            opacity="0.841" :d="`M15 2,L16 1 L${width - 5} 1 `"></path>

      <path :stroke="`url(#verticalGradient${color})`" fill-rule="evenodd" stroke-width="0.025rem" stroke-linecap="butt" stroke-linejoin="miter" fill-opacity="0"
            opacity="0.841" :d="`M${width - 5} 1,L${width - 5} ${height - 15} L${width - 15 - 2} ${height - 1.5}`"></path>

      <path :stroke="`url(#linear-gradientIdle-right${color})`" fill-rule="evenodd" stroke-width="0.025rem" stroke-linecap="butt" stroke-linejoin="miter" fill-opacity="0"
            opacity="0.841" :d="`M${width - 15 - 2} ${height - 1.5},L1 ${height - 1.5}, L1 ${height - 2.5}`"></path>

      <path :stroke="`url(#verticalGradient-top${color})`" fill-rule="evenodd" stroke-width="0.025rem" stroke-linecap="butt" stroke-linejoin="miter" fill-opacity="0"
            opacity="0.841" :d="`M2 ${height - 1.5},L1 ${height - 1.5},L1 ${height - 2.5},L1 16, L15 2`"></path>

      <!--   左上角   -->
      <path fill-rule="evenodd"  :fill="mergedColor[3]"
            d="M1,1 L11,1 L1,11 "/>
      <!--   右下角   -->
      <path fill-rule="evenodd"  :fill="mergedColor[3]"
            :d="`M${width - 5},${height - 1.5} L${width - 10 - 2},${height - 1.5} L${width - 5},${height - 10} `"/>
      <!--   左下角   -->
      <path fill-rule="evenodd"  :stroke="mergedColor[3]" stroke-width="1.5" stroke-linecap="butt" stroke-linejoin="miter" fill-opacity="0"
            :d="`M1,${height - 10} L1,${height - 1.5} L10,${height - 1.5} `"/>
      <!--   右上角   -->
      <path fill-rule="evenodd"  :stroke="mergedColor[3]" stroke-width="1.5" stroke-linecap="butt" stroke-linejoin="miter" fill-opacity="0"
            :d="`M${width - 10 - 4},1 L${width - 5},1 L${width - 5},10 `"/>
      </svg>
    <div class="border-box-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import autoResize from '@jiaminghi/data-view/src/mixin/autoResize'
export default {
  name: 'BorderBox4',
  mixins: [autoResize],
  props: {
    color:{
      type: String,
      default: 'UnKnow'
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    resize:{
      type:String|Number,
      default:0,
    },
    isSelected:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      ref:'border-box-4',
      //第一个、第二个为边框的渐变色，第三个为背景色，第四个为四个角落的图标颜色
      defaultColor: {
        "Idle": ['#085063', '#00d1fa', 'rgba(6, 44, 59,0.8)', '#00D5FF'],
        "OffLine": ['#2c383d', '#969797', 'rgba(26,39,45,0.8)', '#9A9A9A'],
        "Talking": ['#094849', '#01dac1', 'rgba(9,47,52,0.8)', '#01E0C7'],
        "Ringing": ['#093f81', '#3cb1fb', 'rgba(10,53,105,0.8)', '#3EB6FF'],
        "Broading": ['#48215b', '#aa7dde', 'rgba(39,26,57,0.8)', '#AD83E3'],
        "UnKnow": ['#3d3622', '#ce8e30', 'rgba(32,36,31,0.8)', '#D19235']
      },
      mergedColor: [],
      showDiv:true,
    }
  },
  methods: {
  },
  mounted() {

  },
  watch: {
    'color':{
      deep: true,
      immediate: true,
      handler(val) {
        this.mergedColor = this.defaultColor[val];
      }
    },
    width:{
      deep: true,
      immediate: true,
      handler(val) {
        let that = this;
        setTimeout(function () {
          let element = document.getElementById('showDiv')
          if (element) {
            that.width = element.getBoundingClientRect().width
            that.height = element.getBoundingClientRect().height
          }
        },100);
      }
    },
    resize() {
      setTimeout(()=> {
        let element = document.getElementById('showDiv')
        if (element) {
          this.width = element.getBoundingClientRect().width
          this.height = element.getBoundingClientRect().height
        }
      },100);
    },
  },
}
</script>

<style lang="less">
  .border-box-4{
    position: relative;
    width: 100%;
    height: 100%;

    .border-svg-container{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
    }
    .border-box-content{
      position: relative;
      width: 100%;
      height: 100%;
      padding: 0.125rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/border/border-box-4/main.vue